import { useAtom } from 'jotai';
import { stepDateFrequencyModalAtom } from '../atoms';

const useDeliveryFrequencyModalV2 = () => {
  const [stepDateFrequencyModal, setStepDateFrequencyModal] = useAtom(stepDateFrequencyModalAtom);

  return {
    step: stepDateFrequencyModal,
    setStep: setStepDateFrequencyModal
  };
};

export default useDeliveryFrequencyModalV2;
